<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-06-16 12:21:34
    Description : 创作组批量
  -->
  <div class="main">
    <gaia-header :isShowUpload="false" />
    <div style="height: 100px"></div>
    <div
      class="page"
      style="height: 10px; padding-left: 50px; font-size: 14px; color: #999"
    >
      <span @click="jumpTo('/')" style="cursor: pointer">首页</span>
      <span> > </span>
      <span @click="$router.go(-1)" style="cursor: pointer">创作中心</span>
      <span> > </span>
      <span>批量设置</span>
    </div>
    <div class="page box">
      <el-radio-group
        v-model="selectActive"
        style="margin-bottom: 20px"
        @change="pageChange"
        size="small"
      >
        <el-radio-button :label="0">作品</el-radio-button>
        <el-radio-button :label="1">HDR作品</el-radio-button>
        <el-radio-button :label="2">展映作品</el-radio-button>
        <el-radio-button :label="3">素材</el-radio-button>
        <el-radio-button :label="4">学院</el-radio-button>
      </el-radio-group>
      <div
        style="float: right; font-size: 14px; cursor: pointer"
        @click="$router.go(-1)"
      >
        <i class="el-icon-s-operation"></i>
        <span>退出批量</span>
      </div>
      <div class="gary" style="height: 50px; overflow: hidden">
        <el-checkbox @change="selectAll">全选</el-checkbox>
        <el-checkbox v-model="onlySeeSelected">只看选中</el-checkbox>
        <div style="float: right">
          <el-select
            v-if="[1, 2].includes(selectActive)"
            v-model="see"
            placeholder="请选择"
            size="mini"
            @change="pageChange"
          >
            <el-option label="全部" value="" />
            <el-option label="付费" value="pay" />
            <el-option label="免费" value="free" />
          </el-select>
          <el-select
            v-if="[3].includes(selectActive)"
            v-model="MaterialType"
            placeholder="请选择"
            size="mini"
            @change="pageChange"
          >
            <el-option label="全部素材" value="" />
            <el-option label="视频素材" value="video" />
            <el-option label="图片素材" value="picture" />
            <el-option label="音频素材" value="music" />
            <el-option label="模板素材" value="template" />
            <el-option label="其他素材" value="other" />
          </el-select>
          <el-select
            v-if="[4].includes(selectActive)"
            v-model="MaterialType"
            placeholder="请选择"
            size="mini"
            @change="pageChange"
          >
            <el-option label="全部教学" value="" />
            <el-option label="视频教学" value="video" />
            <el-option label="图文教学" value="imgAndText" />
          </el-select>
        </div>
      </div>
      <div v-if="selectActive === 0" class="gary">
        <el-scrollbar style="height: 100%">
          <group-card
            v-for="(item, i) in worksList"
            :key="item.id"
            v-model="checkedList[i]"
            :name="item.title"
            :cover="getCover(item)"
            v-show="!onlySeeSelected || checkedList[i]"
          />
          <div class="loading-btn" v-if="showLoading">
            <i class="el-icon-loading" v-show="loading"></i>
            <span @click="loadMore">
              {{ loading ? "加载中" : "点击加载更多" }}
            </span>
          </div>
        </el-scrollbar>
      </div>
      <div v-if="selectActive === 1" class="gary">
        <el-scrollbar style="height: 100%">
          <group-card
            v-for="(item, i) in hdrsList"
            :key="item.id"
            v-model="checkedList[i]"
            :name="item.title"
            :cover="getCover(item)"
            v-show="!onlySeeSelected || checkedList[i]"
          />
          <div class="loading-btn" v-if="showLoading">
            <i class="el-icon-loading" v-show="loading"></i>
            <span @click="loadMore">
              {{ loading ? "加载中" : "点击加载更多" }}
            </span>
          </div>
        </el-scrollbar>
      </div>
      <div v-if="selectActive === 2" class="gary">
        <el-scrollbar style="height: 100%">
          <group-card
            v-for="(item, i) in showsList"
            :key="item.id"
            v-model="checkedList[i]"
            :name="item.title"
            :cover="getCover(item)"
            v-show="!onlySeeSelected || checkedList[i]"
          />
          <div class="loading-btn" v-if="showLoading">
            <i class="el-icon-loading" v-show="loading"></i>
            <span @click="loadMore">
              {{ loading ? "加载中" : "点击加载更多" }}
            </span>
          </div>
        </el-scrollbar>
      </div>
      <div v-if="selectActive === 3" class="gary">
        <el-scrollbar style="height: 100%">
          <group-card
            v-for="(item, i) in materialsList"
            :key="item.id"
            v-model="checkedList[i]"
            :name="item.title"
            :cover="getCover(item)"
            v-show="!onlySeeSelected || checkedList[i]"
          />
          <div class="loading-btn" v-if="showLoading">
            <i class="el-icon-loading" v-show="loading"></i>
            <span @click="loadMore">
              {{ loading ? "加载中" : "点击加载更多" }}
            </span>
          </div>
        </el-scrollbar>
      </div>
      <div v-if="selectActive === 4" class="gary">
        <el-scrollbar style="height: 100%">
          <group-card
            v-for="(item, i) in courseList"
            :key="item.id"
            v-model="checkedList[i]"
            :name="item.title"
            :cover="item.cover"
            v-show="!onlySeeSelected || checkedList[i]"
          />
          <div class="loading-btn" v-if="showLoading">
            <i class="el-icon-loading" v-show="loading"></i>
            <span @click="loadMore">
              {{ loading ? "加载中" : "点击加载更多" }}
            </span>
          </div>
        </el-scrollbar>
      </div>
      <div class="add-group-manage">添加小组管理</div>
      <div class="gary">
        <el-scrollbar style="height: 100%">
          <div class="title">我创建的小组</div>
          <div class="checkbox">
            <el-checkbox
              v-for="(item, i) in createdGroup"
              :key="item.id"
              v-model="createdGroupCheck[i]"
              style="display: block; padding-left: 20px; margin-bottom: 10px"
            >
              {{ item.name }}
            </el-checkbox>
          </div>
          <div class="title">我加入的小组</div>
          <div class="checkbox">
            <el-checkbox
              v-for="(item, i) in joinedGroup"
              :key="item.id"
              v-model="joinedGroupCheck[i]"
              style="display: block; padding-left: 20px; margin-bottom: 10px"
            >
              {{ item.name }}
            </el-checkbox>
          </div>
          <div class="title">我管理的小组</div>
          <div class="checkbox">
            <el-checkbox
              v-for="(item, i) in manageGroup"
              :key="item.id"
              v-model="manageGroupCheck[i]"
              style="display: block; padding-left: 20px; margin-bottom: 10px"
            >
              {{ item.name }}
            </el-checkbox>
          </div>
        </el-scrollbar>
      </div>
      <el-button
        type="primary"
        size="small"
        style="width: 160px; margin-top: 30px"
        @click="submit"
      >
        保存修改
      </el-button>
    </div>
    <gaia-footer />
  </div>
</template>

<script>
import gaiaHeader from "@/components/gaia-header/gaia-header.vue";
import GaiaFooter from "@/components/gaia-footer/gaia-footer.vue";
import {
  getJoinedList,
  getCreatedList,
  getManageList,
  addMaterialCreation,
  addCourseToGroup,
  addWorksToGroup,
} from "@/api/group.js";
import {
  getWorksList,
  getHdrList,
  getShowList,
  getPersonalMaterial,
  getPersonalCourse,
} from "@/api/personal";
import GroupCard from "./group-card.vue";
export default {
  components: {
    gaiaHeader,
    GaiaFooter,
    GroupCard,
  },
  data() {
    return {
      id: 0,
      selectActive: 0,
      state: "reviewPassed",
      createdGroup: [],
      joinedGroup: [],
      manageGroup: [],
      createdGroupCheck: [],
      joinedGroupCheck: [],
      manageGroupCheck: [],
      loading: false,
      showLoading: true,
      see: "",
      down: true,
      sort: "time",
      courseType: "",
      MaterialType: "",
      page: {
        pageIndex: 1,
        pageSize: 8,
        total: 0,
      },
      worksList: [],
      hdrsList: [],
      showsList: [],
      materialsList: [],
      courseList: [],
      checkedList: [], // 选中的项目
      onlySeeSelected: false, // 只看选中
    };
  },
  created() {
    this.getJoinedList();
    this.getCreatedList();
    this.getManageList();
    this.getWorksList();
    this.id = Number(JSON.parse(localStorage.getItem("user")).account.id);
  },
  methods: {
    jumpTo(url) {
      location.href = url;
    },
    /**
     * 全选
     */
    selectAll(e) {
      if (e) {
        let total = this.page.pageIndex * this.page.pageSize;
        if (total > this.page.total) {
          total = this.page.total;
        }
        this.checkedList = new Array(total).fill(true);
      } else {
        this.checkedList = [];
      }
    },
    /**
     * 创作组列表
     */
    getJoinedList() {
      getJoinedList().then((res) => {
        // console.log(res);
        this.joinedGroup = res.myJoinGroupList.map((el) => {
          return el.group;
        });
      });
    },
    getCreatedList() {
      getCreatedList().then((res) => {
        // console.log(res);
        this.createdGroup = res.groups;
      });
    },
    getManageList() {
      getManageList().then((res) => {
        // console.log(res);
        this.manageGroup = res.groupManagers.map((el) => {
          return el.group;
        });
      });
    },
    /**
     * 处理分页
     */
    flushPage(res) {
      this.page.pageIndex = res.page.pageIndex;
      this.page.pageSize = res.page.pageSize;
      this.page.total = res.page.total;
      if (res.page.pageIndex * res.page.pageSize >= res.page.total) {
        this.showLoading = false;
      }
      setTimeout(() => {
        this.$forceUpdate();
      }, 0);
    },
    /**
     * 选项卡改变
     */
    pageChange() {
      this.checkedList = [];
      this.page.pageIndex = 0;
      this.showLoading = true;
      this.loading = false;
      this.loadMore();
    },
    getCover(data) {
      if (data.cover) {
        return data.cover;
      }
      let cover = "";
      data.video.resources.map((el) => {
        if (el.resourceName === "180") {
          cover = el.resourceKey;
        }
      });
      return cover;
    },
    loadMore() {
      if (this.loading) {
        return;
      }
      const pageIndex = this.page.pageIndex;
      if (this.selectActive === 0) {
        this.getWorksList(pageIndex + 1);
      } else if (this.selectActive === 1) {
        this.getHdrList(pageIndex + 1);
      } else if (this.selectActive === 2) {
        this.getShowList(pageIndex + 1);
      } else if (this.selectActive === 3) {
        this.getPersonalMaterial(pageIndex + 1);
      } else if (this.selectActive === 4) {
        this.getPersonalCourse(pageIndex + 1);
      }
    },
    /**
     * 作品列表
     */
    getWorksList(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        allowDownload: this.allowDownload,
        sort: this.sort,
        state: this.state,
        userId: this.id,
      };
      getWorksList(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          if (pageIndex !== 1) {
            this.worksList = [...this.worksList, ...res.worksList];
          } else {
            this.worksList = res.worksList;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * hdr列表
     */
    getHdrList(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        see: this.see,
        sort: this.sort,
        state: this.state,
        userId: this.id,
      };
      getHdrList(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.hdrsList = res.worksList;
          if (pageIndex !== 1) {
            this.hdrsList = [...this.hdrsList, ...res.worksList];
          } else {
            this.hdrsList = res.worksList;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 展映列表
     */
    getShowList(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        see: this.see,
        sort: this.sort,
        state: this.state,
        userId: this.id,
      };
      getShowList(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.showsList = res.worksList;
          if (pageIndex !== 1) {
            this.showsList = [...this.showsList, ...res.worksList];
          } else {
            this.showsList = res.worksList;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 素材列表
     */
    getPersonalMaterial(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        ...{
          userId: this.id,
          MaterialType: this.MaterialType,
          state: this.state,
        },
      };
      getPersonalMaterial(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          if (pageIndex !== 1) {
            this.materialsList = [...this.materialsList, ...res.materials];
          } else {
            this.materialsList = res.materials;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 学院列表
     */
    getPersonalCourse(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        ...{
          userId: this.id,
          courseType: this.courseType,
          state: this.state,
        },
      };
      getPersonalCourse(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          if (pageIndex !== 1) {
            this.courseList = [...this.courseList, ...res.courseList];
          } else {
            this.courseList = res.courseList;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    addMaterialCreation(data) {
      addMaterialCreation(data)
        .then((res) => {
          this.$message.success("添加成功");
        })
        .catch((res) => {
          this.$message.error("小组作品已存在");
          console.log(res);
        });
    },
    addCourseToGroup(data) {
      addCourseToGroup(data)
        .then((res) => {
          this.$message.success("添加成功");
        })
        .catch((res) => {
          this.$message.error("小组作品已存在");
          console.log(res);
        });
    },
    addWorksToGroup(data) {
      addWorksToGroup(data)
        .then((res) => {
          this.$message.success("添加成功");
        })
        .catch((res) => {
          this.$message.error("小组作品已存在");
          console.log(res);
        });
    },
    submit() {
      let groupIds = [];
      this.createdGroupCheck.map((el, i) => {
        if (el) {
          groupIds.push(this.createdGroup[i].id);
        }
      });
      this.joinedGroupCheck.map((el, i) => {
        if (el) {
          groupIds.push(this.joinedGroup[i].id);
        }
      });
      this.manageGroupCheck.map((el, i) => {
        if (el) {
          groupIds.push(this.manageGroup[i].id);
        }
      });
      let worksIds = [];
      let list = [];
      if (this.selectActive === 0) {
        list = this.worksList;
      } else if (this.selectActive === 1) {
        list = this.hdrsList;
      } else if (this.selectActive === 2) {
        list = this.showsList;
      } else if (this.selectActive === 3) {
        list = this.materialsList;
      } else if (this.selectActive === 4) {
        list = this.courseList;
      }
      this.checkedList.map((el, i) => {
        groupIds.map((gourpId) => {
          worksIds.push({
            groupId: gourpId,
            worksId: list[i].id,
          });
        });
      });
      if (worksIds.length === 0 && groupIds.length === 0) {
        this.$message.error("请至少勾选一个作品和小组");
        return;
      }
      let data = {
        createGroupWorks: worksIds,
      };
      if (this.selectActive === 0) {
        this.addWorksToGroup(data);
      } else if (this.selectActive === 1) {
        this.addWorksToGroup(data);
      } else if (this.selectActive === 2) {
        this.addWorksToGroup(data);
      } else if (this.selectActive === 3) {
        this.addMaterialCreation(data);
      } else if (this.selectActive === 4) {
        this.addCourseToGroup(data);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 300px;
  padding-left: 30px;
  padding-right: 30px;
}
.main {
  background: #ebebeb;
  min-width: 1300px;
}
.box {
  width: 1200px;
  height: auto;
  margin: 40px auto;
  padding-top: 40px;
  padding-bottom: 40px;
  border-radius: 4px;
  background: #ffffff;
}
.gary {
  height: 530px;
  padding: 20px;
  border-radius: 4px;
  background: #f5f5f5;
  overflow: auto;
  .title {
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: 700;
    color: #333;
    margin-bottom: 20px;
  }
}
.add-group-manage {
  margin: 16px 0;
  padding: 4px 0;
  font-size: 16px;
  background: #ffe5e6;
  color: #ff464c;
  text-align: center;
}
.card {
  margin: 8.6px;
}
.card:nth-child(4n-3) {
  margin-left: 0;
}
.card:nth-child(4n + 4) {
  margin-right: 0;
}
.loading-btn {
  margin: 10px 0;
  text-align: center;
  cursor: pointer;
}
</style>
<style lang="less">
.el-scrollbar__wrap {
  overflow-x: hidden !important;
}
.el-scrollbar__bar.is-horizontal {
  display: none;
}
</style>